import React, { useState, Fragment } from 'react'
import { debounce, deburr, compact } from 'lodash'

import { Formik, Form, AutoComplete } from '@components/Form'

const ALLOWED_AUTO_COMPLETE_METHODS = ['click', 'enter', 'type']

const SearchBar = ({
  mapService,
  setRadiusInfo,
  disabled,
  initialState = '',
  fullBorder,
}) => {
  const [suggestions, setSuggestions] = useState([])

  const getAddressSuggestions = value => {
    const parsedValue = deburr(value.toLowerCase().trim())
    let verifiedQuery =
      parsedValue === 'sao paulo'
        ? `${value}, sp`
        : parsedValue === 'rio de janeiro'
        ? `${value}, rj`
        : value

    mapService.geocode(verifiedQuery, results => {
      const geocodeSuggestions = results
        ?.filter(({ address_components }) =>
          address_components?.some(({ types }) => types?.includes('route')),
        )
        .map(({ types, address_components, formatted_address, geometry }) => ({
          identifiers: address_components
            .map(item => item.short_name)
            .join(' ')
            .toLowerCase()
            .trim(),
          name: formatted_address,
          value: { address_components, geometry },
          types,
        }))
      setSuggestions(compact(geocodeSuggestions))
    })
  }

  const debouncedAddressSuggestions = debounce(getAddressSuggestions, 1500)

  const setAddress = async (suggestion, setFieldValue) => {
    const { value, name } = suggestion
    let address = {
      lat: value.geometry.location.lat(),
      lng: value.geometry.location.lng(),
    }

    const buildAddress = component => {
      if (component.types.includes('street_number'))
        address.number = component.long_name
      if (component.types.includes('route'))
        address.street = component.long_name
      if (component.types.includes('sublocality'))
        address.neighborhood = component.long_name
      if (component.types.includes('administrative_area_level_2'))
        address.city = component.long_name
      if (component.types.includes('administrative_area_level_1'))
        address.uf = component.long_name
      if (component.types.includes('country'))
        address.country = component.long_name
    }

    value.address_components.forEach(buildAddress)

    if (verifyCompleteAddress(address)) {
      !setRadiusInfo(address, name) && setFieldValue('search', '')
    } else {
      mapService.geocode(`${address.lat}, ${address.lng}`, results => {
        results[0].address_components.forEach(buildAddress)
        !setRadiusInfo(address, results[0].formatted_address) &&
          setFieldValue('search', '')
      })
    }
  }

  const verifyCompleteAddress = address => {
    if (
      address.number &&
      address.street &&
      address.neighborhood &&
      address.city &&
      address.uf &&
      address.country
    )
      return true

    return false
  }

  return (
    <Fragment>
      <Formik
        enableReinitialize
        initialValues={{ search: initialState }}
        onSubmit={() => null}
      >
        {({ values, setFieldValue, handleSubmit }) => (
          <Form onSubmit={handleSubmit}>
            <AutoComplete
              fullBorder={fullBorder}
              disabled={disabled}
              autoComplete="off"
              name="search"
              id="searchBar"
              value={values.search}
              suggestions={suggestions}
              onSuggestionSelected={(_, { suggestion }) =>
                setAddress(suggestion, setFieldValue)
              }
              onChange={(_, { newValue, method }) => {
                if (ALLOWED_AUTO_COMPLETE_METHODS.includes(method)) {
                  setFieldValue('search', newValue)
                  debouncedAddressSuggestions(newValue)
                }
              }}
              placeholder="Busque um endereço completo"
            />
          </Form>
        )}
      </Formik>
    </Fragment>
  )
}

export default SearchBar
